enum SubmissionChannels {
  Instagram = 'instagram',
  Facebook = 'facebook',
  Pinterest = 'pinterest',
  TikTok = 'tiktok',
  X = 'x',
  YouTube = 'youtube',
  Snapchat = 'snapchat',
}

export { SubmissionChannels }
